import {
    Wrapper,
    Container,
    ContainerWrapper,
    Title,
    Description,
    Bold,
    ImageBox,
    BorderLeft,
    BorderRight,
    KunoImage,
} from './AboutStyle';

const About = () => {
    return (
        <Wrapper id="about">
            {/* left */}
            <BorderLeft
                top={'10px'}
                src="../../config/images/top-left.webp"
                alt="corner image"
            />
            <BorderLeft
                bottom={'10px'}
                src="../../config/images/bottom-left.webp"
                alt="corner image"
            />

            {/* right */}
            <BorderRight
                top={'10px'}
                src="../../config/images/top-right.webp"
                alt="corner image"
            />
            <BorderRight
                bottom={'10px'}
                src="../../config/images/bottom-right.webp"
                alt="corner image"
            />

            <Container>
                <Title>About Kuno</Title>

                <ContainerWrapper>
                    <Description>
                        Kuno NFT is a collection of 10,010 Weird and unique NFT
                        project randomly generated on the Ethereum Blockchain.{' '}
                        <br /> <br />
                        <Bold>What is Kunos?</Bold> <br />
                        Kunos are mysterious creatures that live in the Dark
                        Deep of Kashigara Forest. Human call them Spirit guide,
                        Nature Ancient Spirits. Sometimes mischievous and
                        dangerous, sometimes helping travelers who are lost
                        inside the forest. Their behavior is reflected in how
                        you react and treat them.
                    </Description>
                    <ImageBox>
                        <KunoImage autoPlay loop muted playsInline>
                            <source
                                src="/config/images/kuno1.webm"
                                type="video/webm"
                            />
                            <source
                                src="/config/images/kuno1.mp4"
                                type="video/mp4"
                            />
                        </KunoImage>
                    </ImageBox>
                </ContainerWrapper>
            </Container>
        </Wrapper>
    );
};

export default About;
